import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/common/Dashboard";
import FeaturedForm from "../pages/common/FeaturedForm";
import Withdraw from "../pages/Fundraiser/Withdraw";
import AddBank from "../pages/Fundraiser/AddBank";
import BanksList from "../pages/Fundraiser/BanksList";
import FundraiserReferralList from "../pages/Fundraiser/FundraiserReferralList";
import ReferForm from "../pages/Fundraiser/ReferForm";
import Assets from "../pages/Fundraiser/Assets";
import Marketing from "../pages/Fundraiser/Marketing";
import FundraiserGettingStarted from "../pages/Fundraiser/GettingStarted";
import FundraiserCreateAccount from "../pages/Fundraiser/CreateAccount";
import FundraiserAccountCreated from "../pages/Fundraiser/AccountCreated";
import FundraiserAccountLogin from "../pages/Fundraiser/AccountLogin";
import FundraiserSetUpAccount from "../pages/Fundraiser/SetUpAccount";
import Welcome from "../pages/common/Welcome";
import MerchantOnboardLayout from "../components/Merchant/MerchantOnboarding/MerchantOnboardLayout";
import { useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import Transactions from "../pages/Fundraiser/Transactions";
import EditProfileForm from "../pages/Fundraiser/EditProfileForm";
import MerchantVisibility from "../pages/Fundraiser/MerchantVisibility";

const FundraiserRoutes = () => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );

  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role;
  const isRoleMatching = isAuthenticated && normalizedRole == "fundraiser";
  const getRedirectPath = () => {
    switch (normalizedRole) {
      case "merchant":
        return "/merchant/dashboard";
      // return "/merchant/welcome"; // Coming Soon screen commented out
      case "fundraiser":
        return "/fundraiser/dashboard";
      default:
        return "/dashboard"; // Default dashboard
    }
  };

  useEffect(() => {
    setIsAuthenticated(!!token);
  }, [token]);

  return (
    <Routes>
      <Route
        path="/fundraiser/dashboard"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <Dashboard />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="/fundraiser/transactions"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Transactions />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/withdraw"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Withdraw />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/add-bank"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? <AddBank /> : <Navigate to={getRedirectPath()} />
            }
          />
        }
      />
      <Route
        path="/fundraiser/banks-list"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <BanksList />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/refer-merchant"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <ReferForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/referral-list"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <FundraiserReferralList />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/merchant-visibility"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <MerchantVisibility />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/edit-profile"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <EditProfileForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/assets"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? <Assets /> : <Navigate to={getRedirectPath()} />
            }
          />
        }
      />
      <Route
        path="/fundraiser/marketing"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Marketing />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/welcome"
        element={
          isRoleMatching ? <Welcome /> : <Navigate to={getRedirectPath()} />
        }
      />
      <Route
        path="/fundraiser/getting-started"
        element={
          <MerchantOnboardLayout
            element={
              !isAuthenticated ? (
                <FundraiserGettingStarted />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="/fundraiser/account-setup"
        element={<FundraiserSetUpAccount />}
      />
      <Route
        path="/fundraiser/create-account"
        element={
          <MerchantOnboardLayout element={<FundraiserCreateAccount />} />
        }
      />
      <Route
        path="/fundraiser/welcome-onboard/:verificationCode"
        element={
          <MerchantOnboardLayout element={<FundraiserCreateAccount />} />
        }
      />
      <Route
        path="/fundraiser/account-created"
        element={
          <MerchantOnboardLayout element={<FundraiserAccountCreated />} />
        }
      />
      <Route
        path="/fundraiser/account-login"
        element={
          <MerchantOnboardLayout element={<FundraiserAccountLogin />} />
        }
      />
    </Routes>
  );
};

export default FundraiserRoutes;
